import {
    signalingManager,
} from '@/utils/audioHandler'
import {
    notificationStore,
} from '@/utils/notificationStore'
import {
    MessageBox,
} from 'element-ui'

class NotificationMananger {
    constructor() {
        this.context = null
        this.params = null

        this.pull = {}
    }

    setContext(context) {
        this.context = context
        return this
    }

    setParams(params) {
        this.params = params
        return this
    }

    addToPull(params) {
        const { id } = params
        this.pull[id] = params
        return this
    }

    checkPage(page) {
        return this.context.$route.path === page
    }

    readNotifications(notificationId) {
        if (notificationId) {
            const notifications = [notificationId]
            this.context.$store.dispatch('readNotification', notifications)
        }
    }

    async onMessage(id) {
        const params = this.pull[id]
        const instance = this.context
        const { item } = params

        const isChat = this.checkPage('/admin/chat')

        instance.$Progress.start()

        await instance.$store.dispatch('getDialogs', item.dialog_type)
        await instance.$store.dispatch('getDialog', {
            type: item.dialog_type,
            dialogId: item.dialog_type === 'masters' ? item.master_id : item.client_id,
        })

        instance.$Progress.finish()

        if (!isChat) {
            instance.$router.push({
                name: params.route.name,
                params: params.route,
            })
        }
        this.readAll(params.data)
    }

    onNewLandingRequest(id) {
        const params = this.pull[id]

        const instance = this.context
        const isAdminRequests = this.checkPage('/admin/requests')
        const { landing_request_id } = params.route
        const routerParams = {
            landing_request_id,
        }

        this.readAll(params.data)

        if (!isAdminRequests) {
            this.context.$router.push({
                name: params.route.name,
                params: routerParams,
            })
        } else if (instance.$store.getters['requests/showModalAdd']) {
            // eslint-disable-next-line new-cap
            new MessageBox.confirm('Sie haben Änderungen nicht gespeichert, speichern und fortfahren?', 'Bestätigen', {
                distinguishCancelAndClose: true,
                confirmButtonText: 'Schließen Sie das aktuelle Modal',
                cancelButtonText: 'Bleib im Strom',
            }).then(() => {
                instance.$store.commit('requests/setShowModalAdd', false)
                instance.$store.commit('requests/cleatNotification')
                // requests/cleatNotification
                setTimeout(() => {
                    instance.$store.commit('requests/setNotification', {
                        show: true,
                        id: routerParams.landing_request_id,
                    })
                }, 500)
            }).catch(() => {
                console.log('err')
            })
        } else {
            instance.$store.commit('requests/setNotification', {
                show: true,
                id: routerParams.landing_request_id,
            })
        }

        if (notificationStore.has(landing_request_id)) {
            if (signalingManager.isPlaying) {
                signalingManager.stop()
            }

            const notification = notificationStore.get(landing_request_id)
            notification.close()
            notificationStore.add(landing_request_id, null)
        }
    }

    async onNewRequest(id) {
        const params = this.pull[id]
        const instance = this.context

        const isOrdersPage = this.checkPage('/admin/orders')
        const { item } = params

        if (!isOrdersPage) {
            instance.$router.push({
                name: params.route.name,
                params: {
                    requestId: item.request_id,
                },
            })
        } else if (instance.$store.getters['orders/showModal']) {
            // eslint-disable-next-line new-cap
            new MessageBox.confirm('Sie haben Änderungen nicht gespeichert, speichern und fortfahren?', 'Bestätigen', {
                distinguishCancelAndClose: true,
                confirmButtonText: 'Schließen Sie das aktuelle Modal',
                cancelButtonText: 'Bleib im Strom',
            }).then(() => {
                instance.$store.commit('orders/setToggleModalState', false)

                setTimeout(async () => {
                    await instance.$store.dispatch('orders/fetchById', item.request_id)
                    instance.$store.commit('orders/setToggleModalState', true)
                }, 500)
            }).catch(() => {
                console.log('err')
            })
        } else {
            await instance.$store.dispatch('orders/fetchById', item.request_id)
            instance.$store.commit('orders/setToggleModalState', true)
        }

        const { request_id } = item
        if (notificationStore.has(request_id)) {
            if (signalingManager.isPlaying) {
                signalingManager.stop()
            }

            const notification = notificationStore.get(request_id)
            notification.close()
            notificationStore.add(request_id, null)
        }

        this.readAll(params.data)
    }

    async onRegistration(id) {
        const params = this.pull[id]
        const instance = this.context
        const isClientPage = this.checkPage('/admin/clients')

        this.readAll(params.data)

        instance.$Progress.start()
        await instance.$store.dispatch('getClientsData', {})
        instance.$Progress.finish()

        if (!isClientPage) {
            instance.$router.push({
                name: 'clients',
            })
        }
    }

    readAll(notifications = null) {
        const data = notifications || this.params.data

        if (data) {
            this.markNewNotification(data)
        }
    }

    markNewNotification(data) {
        const notifications = data.reduce((accum, item) => {
            accum.push(item.id)
            return accum
        }, [])

        this.context.$store.dispatch('readNotification', notifications)
    }
}

export {
    NotificationMananger,
}
